import {writable} from "svelte/store";

export const data = writable({respuestas:[]});
export const db = writable({});
export const docs = writable([]);
